







































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import { TopDataItem, DistroDataSet, Filter } from "@/classes/DistroDataSet";
import TopCompareChart from "@/components/TopCompareChart.vue";
import TopWidget from "@/components/TopWidget.vue";

@Component({
  components: {
    "top-compare-chart": TopCompareChart,
    "top-widget": TopWidget
  }
})
export default class Release extends Vue {
  @Prop() public dataSet!: DistroDataSet;
  @Prop() public datesFilter!: Date[];

  topReleasesByRevenue: TopDataItem[] = [];
  bottomReleasesByRevenue: TopDataItem[] = [];

  topCount = 5;

  mounted() {
    this.setData();
  }

  @Watch("datesFilter")
  @Watch("release")
  setData() {
    const [fromDate, toDate] = this.$props.datesFilter;

    const filter: Filter = {
      fromDate: fromDate,
      toDate: toDate
    };
    this.topReleasesByRevenue = this.$props.dataSet.getTopReleasesByRevenue(
      filter,
      100
    );
    this.bottomReleasesByRevenue = this.$props.dataSet.getTopReleasesByRevenue(
      filter,
      100,
      "asc"
    );

    for (
      let releaseNo = 0;
      releaseNo < Math.min(this.topCount, this.topReleasesByRevenue.length);
      releaseNo++
    ) {
      filter.isrc = this.topReleasesByRevenue[releaseNo].id;
      this.topReleasesByRevenue[
        releaseNo
      ].monthlyTotals = this.$props.dataSet.getMonthTotals(filter);
    }
  }
}
